import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadManagerService, UploadState } from '../../service/upload-manager.service';

@Component({
  selector: 'app-upload-widget',
  templateUrl: './upload-widget.component.html',
  styleUrls: ['./upload-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadWidgetComponent {
  state$: Observable<UploadState> = this.manager.state$;

  constructor(private manager: UploadManagerService) {}

  getPhaseLabel(phase: UploadState['phase']): string {
    switch (phase) {
      case 'uploading': return 'Subiendo…';
      case 'processing': return 'Procesando video…';
      case 'folder-adding': return 'Agregando a carpeta…';
      case 'saving': return 'Guardando…';
      case 'completed': return 'Completado';
      case 'failed': return 'Error';
      case 'canceled': return 'Cancelado';
      default: return '';
    }
  }

  close() { this.manager.clear(); }
}
